module.exports = __webpack_public_path__ + "static/media/item_5_27_comp.e18433d7.png";